import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Booked.css';

export interface IBookedProps {
  children: React.ReactNode;
  fromCian?: boolean;
}

export const Booked: React.FC<IBookedProps> = ({ children, fromCian }) => {
  return (
    <div className={styles['container']}>
      {children}
      <div className={styles['banner']}>
        <IconFunctionalLock16 />
        <span className={styles['text']}>Квартира забронирована {fromCian && 'на Циан'}</span>
      </div>
    </div>
  );
};
